import { useNavigate } from "react-router";
import useQueryParams from "./useQueryParams";

export default function useAssetChargesSummary() {
  const navigate = useNavigate();
  const queryParams = useQueryParams();

  const assetChargesSummaryId = queryParams.get("assetChargesSummaryId");
  const assetReplayLogId = queryParams.get("assetReplayLogId");
  const startDate = queryParams.get("startDate");
  const endDate = queryParams.get("endDate");
  const editingCharges = queryParams.get("editingCharges") === "true";
  const detailsExpanded = queryParams.get("detailsExpanded") === "true";
  const showChargesSummary = Boolean(assetChargesSummaryId);

  const handleClose = () => {
    queryParams.delete("assetChargesSummaryId");
    queryParams.delete("assetReplayLogId");
    queryParams.delete("startDate");
    queryParams.delete("endDate");
    queryParams.delete("editingCharges");
    queryParams.delete("detailsExpanded");
    navigate({ search: queryParams.toString() });
  };

  const handleUpdateReplayLogId = (newReplayLogId) => {
    if (newReplayLogId && typeof newReplayLogId === 'string' && newReplayLogId !== 'undefined') {
      queryParams.set("assetReplayLogId", newReplayLogId);
      navigate({ search: queryParams.toString() });
    }
  };

  const handleEditCharges = () => {
    queryParams.set("editingCharges", "true");
    queryParams.set("detailsExpanded", "true");
    navigate({ search: queryParams.toString() });
  };

  const handleStopEditing = () => {
    queryParams.delete("editingCharges");
    queryParams.delete("detailsExpanded");
    navigate({ search: queryParams.toString() });
  };

  const handleToggleDetails = (expanded) => {
    if (expanded) {
      queryParams.set("detailsExpanded", "true");
    } else {
      queryParams.delete("detailsExpanded");
    }
    navigate({ search: queryParams.toString() });
  };

  return {
    assetId: assetChargesSummaryId,
    assetReplayLogId,
    startDate,
    endDate,
    editingCharges,
    detailsExpanded,
    showChargesSummary,
    handleClose,
    handleUpdateReplayLogId,
    handleEditCharges,
    handleStopEditing,
    handleToggleDetails,
  };
}
